import { useCallback, useMemo, useState } from 'react';
import { ListItemField } from '@common-fe/common-fe';

const MAX_COLLAPSED_FIELDS = 3;
const MAX_GRID_COLUMNS = 3;

interface Params {
  itemKey?: string;
  gridFields: ListItemField[];
  isEditMode?: boolean;
  onSelect?: (value?: string) => void;
}

export const useRadioCardLayout = ({ itemKey, gridFields, isEditMode, onSelect }: Params) => {
  const [isExpanded, setIsExpanded] = useState(!isEditMode);

  const visibleGridFields = useMemo(
    () => (isExpanded ? gridFields : gridFields.slice(0, MAX_COLLAPSED_FIELDS)),
    [isExpanded, gridFields]
  );

  const gridColumns = useMemo(
    () => Array.from(
      { length: Math.min(Math.max(visibleGridFields.length, 1), MAX_GRID_COLUMNS) },
      () => '1fr'
    ),
    [visibleGridFields.length]
  );

  const handleToggleExpand = useCallback(() => setIsExpanded((prev) => !prev), []);

  const handleSelect = useCallback(() => {
    if (onSelect && itemKey) {
      onSelect(itemKey);
      setIsExpanded(true);
    }
  }, [itemKey, onSelect]);

  return {
    isExpanded,
    visibleGridFields,
    gridColumns,
    handleToggleExpand,
    handleSelect,
  };
};

export default useRadioCardLayout;
